(function () {
  'use strict';

  function initSlider(track) {
    var sectionId = track.id.replace('sbc-track-', '');
    var fill = document.getElementById('sbc-fill-' + sectionId);
    if (!fill) return;

    function updateFill() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        fill.style.width = '100%';
        return;
      }
      var progress = track.scrollLeft / maxScroll;
      fill.style.width = (progress * 100).toFixed(2) + '%';
    }

    track.addEventListener('scroll', updateFill, { passive: true });

    // Initial paint
    updateFill();

    // Re-run after images may have loaded and shifted scrollWidth
    window.addEventListener('load', updateFill);
  }

  function initAll() {
    document
      .querySelectorAll('.sbc-slider__track')
      .forEach(function (track) {
        initSlider(track);
      });
  }

  // Standard page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: section reloaded or block added/removed
  document.addEventListener('shopify:section:load', function (e) {
    var track = e.target.querySelector('.sbc-slider__track');
    if (track) initSlider(track);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var track = e.target.closest('.sbc-slider');
    if (track) {
      var t = track.querySelector('.sbc-slider__track');
      if (t) {
        var fill = document.getElementById(t.id.replace('sbc-track-', 'sbc-fill-'));
        if (fill) {
          var maxScroll = t.scrollWidth - t.clientWidth;
          fill.style.width = maxScroll > 0
            ? ((t.scrollLeft / maxScroll) * 100).toFixed(2) + '%'
            : '100%';
        }
      }
    }
  });

})();